import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { InputTextModule } from 'primeng/inputtext';

@Component({
    selector: 'formly-primeng-field',
    imports: [ReactiveFormsModule, InputTextModule],
    // A static `type="number"` is required for Angular to bind
    // NumberValueAccessor — with a dynamic `[type]` binding the input always
    // uses DefaultValueAccessor and the control value stays a string. Split the
    // template so number fields get a real numeric control value.
    // (Mirrors @ngx-formly/primeng's own input type.)
    template: `
        @if (props.type === 'number') {
            <input type="number" pInputText class="w-full" [id]="key" [formControl]="formControl" />
        } @else {
            <input pInputText class="w-full" [id]="key" [type]="props.type || 'text'" [formControl]="formControl" />
        }
    `,
})

export class InputTextFieldCosmos extends FieldType<FieldTypeConfig> {

    ngOnInit() { }
}